export const okrCreationPanelStateSelector = (state) => state.okrCreationPanelState.okrDetails;
export const okrInitializedStateSelector = (state) => state.okrCreationPanelState.initializedState;
export const modifiedFieldsSelector = (state) => state.okrCreationPanelState.modifiedFields;
